import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { ampli } from '../../../../ampli';
import { Icon } from '../../../../components/common/icon/Icon';
import { PLUVA_SHOP_URL, pageInfo } from '../../../../constants/pageInfo/pageInfo.constant';
import { postMessageToRN } from '../../../../utils/RNCommunicator/postMessageToRN.util';

export const DirectMenuSection = () => {
  const navigate = useNavigate();

  const handlePluvaShopCardClick = () => {
    if (window.ReactNativeWebView) {
      postMessageToRN({ messageKey: 'link', messageParam: PLUVA_SHOP_URL });
    } else {
      window.location.href = PLUVA_SHOP_URL;
    }
  };

  const handleSellTractorCardClick = () => navigate(pageInfo.sellTractorEntryPage.path);

  const handlePluvaAutoCardClick = () => {
    ampli.홈플루바오토살펴보기버튼클릭();
    navigate(pageInfo.pluvaAutoPage.path);
  };

  return (
    <DirectMenuContainer>
      <TopSection>
        <Card onClick={handlePluvaShopCardClick}>
          <TitleContainer>
            <TitleWrapper>
              <Tooltip>
                <TooltipBody color={'#FF3049'}>
                  <TooltipText>{'신규'}</TooltipText>
                </TooltipBody>
                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6" fill="none">
                  <path
                    d="M5.24537e-07 -0.000733121L3.16795 4.75119C3.56377 5.34492 4.43623 5.34493 4.83205 4.75119L8 -0.000732422L5.24537e-07 -0.000733121Z"
                    fill="#FF3049"
                  />
                </svg>
              </Tooltip>
              <Title>{'플루바 샵'}</Title>
            </TitleWrapper>
            <Icon name="AngleRight" size="Medium" fill="#858894" />
          </TitleContainer>
          <Description>{'농업을 위한 최고급\n농기계 마트'}</Description>
          <IconSection>
            <Icon name="PluvaShop" width={40} height={40} />
          </IconSection>
        </Card>
        <Card onClick={handleSellTractorCardClick}>
          <TitleContainer>
            <Title>{'트랙터 팔기'}</Title>
            <Icon name="AngleRight" size="Medium" fill="#858894" />
          </TitleContainer>
          <Description>{'빠르고 간편한\n내 트랙터 판매'}</Description>
          <IconSection>
            <Icon name="Tractor" width={40} height={40} />
          </IconSection>
        </Card>
      </TopSection>

      <BottomSection>
        <Card onClick={handlePluvaAutoCardClick}>
          <TitleContainer>
            <TitleWrapper>
              <Tooltip>
                <TooltipBody color={'#34C77E'}>
                  <TooltipText>{'농기계 자율 주행'}</TooltipText>
                </TooltipBody>
                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6" fill="none">
                  <path
                    d="M5.24537e-07 -0.000733121L3.16795 4.75119C3.56377 5.34492 4.43623 5.34493 4.83205 4.75119L8 -0.000732422L5.24537e-07 -0.000733121Z"
                    fill="#34C77E"
                  />
                </svg>
              </Tooltip>
              <Title>{'플루바 오토 살펴보기'}</Title>
            </TitleWrapper>
            <Icon name="AngleRight" size="Medium" fill="#858894" />
          </TitleContainer>
          <Description>{'내 트랙터와 이앙기를 자율주행 농기계로!'}</Description>
        </Card>
      </BottomSection>
    </DirectMenuContainer>
  );
};

const DirectMenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--radius-large, 16px);
  align-self: stretch;

  padding: 0px var(--radius-large, 16px);
`;

const TopSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: var(--radius-large, 16px);
  align-self: stretch;
`;

const BottomSection = styled.div`
  display: flex;
  align-items: center;
  gap: var(--radius-medium, 8px);
  align-self: stretch;
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--radius-small, 4px);
  flex: 1 0 0;

  padding: var(--radius-large, 16px);

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Monochrome-grey10, #f2f2f7);

  cursor: pointer;
`;

const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

const Title = styled.h2`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* Display/Large/l-bold */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 20.8px */
`;

const Description = styled.pre`
  color: var(--Light-Scheme-Monochrome-grey100, #858894);

  /* Display/Medium/m-regular */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 18.2px */
`;

const IconSection = styled.div`
  height: 23px;

  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 10px;
  align-self: stretch;

  @media screen and (max-width: 340px) {
    display: none;
  }
`;

const TitleWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;

  position: relative;
`;

const TooltipBody = styled.div<{ color: string }>`
  display: flex;
  align-items: center;
  gap: var(--radius-medium, 8px);

  padding: var(--radius-small, 4px) var(--radius-medium, 8px);

  border-radius: var(--radius-medium, 8px);
  background: ${(props) => props.color};
`;

const Tooltip = styled.div`
  max-width: 300px;

  display: flex;
  flex-direction: column;
  align-items: center;

  position: absolute;

  left: 0px;
  top: -27.336px;

  border-radius: var(--radius-medium, 8px);
`;

const TooltipText = styled.span`
  color: var(--Light-Scheme-Monochrome-white, #fff);

  /* Display/X-Small/xs-bold */
  font-family: Pretendard;
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 13px */
`;
